var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lx-editor"},[_c('no-ssr',[_c('ck-editor-field',_vm._g(_vm._b({ref:"editor",attrs:{"value":_vm.value}},'ck-editor-field',_vm.$attrs,false),_vm.$listeners))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }